// ============================================================================
// ENTITY TAX ACCOUNT (GL mapping) SERVICE (ADR-0019) — entity-scoped.
// ============================================================================

import { get, post, put, del } from '../client/axiosClient';
import { entityTaxAccountEndpoints } from '../endpoints/tax.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse, BackendPagedResult, PaginatedResponse, EmptyResponse, ID,
  EntityTaxAccountDto, CreateEntityTaxAccountRequest, UpdateEntityTaxAccountRequest, EntityTaxAccountQueryParams,
} from '../types';

class EntityTaxAccountService {
  async getAll(params?: EntityTaxAccountQueryParams): Promise<PaginatedResponse<EntityTaxAccountDto>> {
    const endpoint = params ? buildEndpointWithQuery(entityTaxAccountEndpoints.list(), params) : entityTaxAccountEndpoints.list();
    const response = await get<ApiResponse<BackendPagedResult<EntityTaxAccountDto>>>(endpoint);
    const paged = response.data.data;
    return {
      success: response.data.success, message: response.data.message,
      data: Array.from(paged.items || []),
      pagination: {
        currentPage: paged.page, pageSize: paged.pageSize, totalPages: paged.totalPages,
        totalItems: paged.totalCount, hasNextPage: paged.hasNext, hasPreviousPage: paged.hasPrevious,
      },
    };
  }
  async create(data: CreateEntityTaxAccountRequest): Promise<EntityTaxAccountDto> {
    const r = await post<ApiResponse<EntityTaxAccountDto>>(entityTaxAccountEndpoints.create(), data);
    return r.data.data;
  }
  async update(id: ID, data: UpdateEntityTaxAccountRequest): Promise<EntityTaxAccountDto> {
    const r = await put<ApiResponse<EntityTaxAccountDto>>(entityTaxAccountEndpoints.update(id), data);
    return r.data.data;
  }
  async delete(id: ID, rowVersion: number): Promise<EmptyResponse> {
    const url = buildEndpointWithQuery(entityTaxAccountEndpoints.delete(id), { rowVersion });
    const r = await del<EmptyResponse>(url);
    return r.data;
  }
}

export const entityTaxAccountService = new EntityTaxAccountService();
export default entityTaxAccountService;
